var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.cardCashoutModal
        ? _c(
            "EmptyCardModal",
            {
              ref: "modalCard",
              attrs: {
                modalData: _vm.cardCashoutModal,
                onModalClose: (reset) => (_vm.cardCashoutModal = null),
                onModalAccept: _vm.saveCashOut,
              },
            },
            [
              _vm._t("default", function () {
                return [
                  [
                    _c(
                      "div",
                      [
                        !_vm.cardCashoutModal.cashOut
                          ? [
                              _c("div", { staticClass: "flex" }, [
                                _c(
                                  "div",
                                  [
                                    _c("p", [
                                      _vm._v("По заявкам числится: "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.totalCardsSum.toLocaleString(
                                              "ru-RU"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        "В работе заявки:\n                  "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            (
                                              _vm.noCashOrders?.ordersInProgress
                                                ?.total_sum || 0
                                            ).toLocaleString("ru-RU")
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v("Зачисление по SMS: "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            (
                                              _vm.noCashOrders.incomesBySms || 0
                                            ).toLocaleString("ru-RU")
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v("Баланс на картах: "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            (
                                              _vm.$refs.cardsBalance
                                                ?.totalAmount || 0
                                            ).toLocaleString("ru-RU")
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v("Снято с карт: "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.noCashOrders.cashOutSum.toLocaleString(
                                              "ru-RU"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _vm.cardCashoutModal.updateBalance
                                      ? _c("LoadingButton", {
                                          attrs: {
                                            title: "Обновить баланс",
                                            type: "button",
                                            loading: _vm.btnBalanceLoading,
                                            color: _vm.$constants.SUCCESS_COLOR,
                                            onClick: () =>
                                              _vm.updateCardsBalance(),
                                            className:
                                              "btn btn-outline-success btn-sx",
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "ml-2 border-left pl-2" },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(_vm.totalCardsSum) +
                                          " + " +
                                          _vm._s(
                                            _vm.noCashOrders?.ordersInProgress
                                              ?.total_sum || 0
                                          ) +
                                          " +\n                  " +
                                          _vm._s(
                                            _vm.noCashOrders.incomesBySms || 0
                                          ) +
                                          " - " +
                                          _vm._s(
                                            _vm.$refs.cardsBalance
                                              ?.totalAmount || 0
                                          ) +
                                          " =\n                  "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm
                                              .getControlSum()
                                              .toLocaleString("ru-RU")
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]
                          : [
                              _c("div", { staticClass: "alert alert-info" }, [
                                _c("p", [
                                  _vm._v("При снятии суммы "),
                                  _c("strong", [_vm._v("0")]),
                                  _vm._v(" - обналичивание будет удалено"),
                                ]),
                              ]),
                            ],
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Сумма снятия"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.cardCashoutModal.sum,
                                  expression: "cardCashoutModal.sum",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { type: "number" },
                              domProps: { value: _vm.cardCashoutModal.sum },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.cardCashoutModal,
                                    "sum",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "input-group-prepend input-group-append",
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "input-group-text" },
                                  [_vm._v(_vm._s(_vm.getControlSum(true)))]
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ],
                      2
                    ),
                  ],
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      false
        ? _c(
            "div",
            { staticClass: "hidden" },
            [
              _vm._l(_vm.balance.start, function (bal, curr) {
                return bal.orders
                  ? _c("p", [
                      _vm._v(
                        "\n      Сальдо " +
                          _vm._s(_vm.$AllCurrencies[curr].currency) +
                          ": "
                      ),
                      _c("strong", [
                        _vm._v(_vm._s(bal.orders.toLocaleString("ru-RU"))),
                      ]),
                    ])
                  : _vm._e()
              }),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Заявки " + _vm._s(_vm.$AllCurrencies[33].currency) + ": "
                ),
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      (_vm.orders?.grouped?.total_pass ?? 0).toLocaleString(
                        "ru-RU"
                      )
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm.dayData && _vm.dayData.expenses && _vm.dayData.expenses.length
                ? [
                    _c("p", [_vm._v("Расходы:")]),
                    _vm._v(" "),
                    _vm._l(_vm.dayData.expenses, function (exp) {
                      return _c("p", [
                        _vm._v(
                          _vm._s(_vm.$AllCurrencies[exp.currency_id].currency) +
                            ": "
                        ),
                        _c("strong", [
                          _vm._v(
                            "-\n        " +
                              _vm._s(exp.sum.toLocaleString("ru-RU"))
                          ),
                        ]),
                      ])
                    }),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.dayData &&
              _vm.dayData.exchanges &&
              _vm.dayData.exchanges.length
                ? [
                    _c("p", [_vm._v("Покупка валют:")]),
                    _vm._v(" "),
                    _vm._l(_vm.dayData.exchanges, function (exch) {
                      return _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$AllCurrencies[exch.currency_id].currency
                          ) + ":\n        "
                        ),
                        _c("strong", [
                          _vm._v(_vm._s(exch.sum.toLocaleString("ru-RU"))),
                        ]),
                      ])
                    }),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.useCashOut
                ? [
                    _c("p", [
                      _vm._v(
                        "Конверт " +
                          _vm._s(_vm.$AllCurrencies[33].currency) +
                          ":\n        "
                      ),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.balance.start[33].cash.toLocaleString("ru-RU")
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "ЗП " +
                          _vm._s(_vm.$AllCurrencies[33].currency) +
                          ":\n        "
                      ),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            (
                              _vm.balance.start[33].salary +
                              (_vm.orders.grouped.total_salary || 0)
                            ).toLocaleString("ru-RU")
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "Почтовые р. " +
                          _vm._s(_vm.$AllCurrencies[33].currency) +
                          ":\n        "
                      ),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            (
                              _vm.balance.start[33].post +
                              (_vm.orders.grouped.total_post || 0)
                            ).toLocaleString("ru-RU")
                          )
                        ),
                      ]),
                    ]),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.dayData && _vm.dayData.incashmentsData.incashment
                ? [
                    _c("hr"),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("Снятие: "),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.moment(
                              _vm.dayData.incashmentsData.incashment
                                .report_date,
                              "HH:mm DD.MM.YYYY"
                            )
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("Снятая сумма: "),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            (
                              _vm.dayData.incashmentsData.incashment.sum || 0
                            ).toLocaleString("ru-RU")
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("Заявки: "),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            (
                              _vm.dayData.incashmentsData.incashment
                                .adm_amount || 0
                            ).toLocaleString("ru-RU")
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("ЗП: "),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            (
                              _vm.dayData.incashmentsData.incashment
                                .salary_amount || 0
                            ).toLocaleString("ru-RU")
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("Почтовые р.:\n        "),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            (
                              _vm.dayData.incashmentsData.incashment
                                .post_amount || 0
                            ).toLocaleString("ru-RU")
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("Конверт: "),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            (
                              _vm.dayData.incashmentsData.incashment
                                .cash_amount || 0
                            ).toLocaleString("ru-RU")
                          )
                        ),
                      ]),
                    ]),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.dayData &&
              _vm.dayData.incomes &&
              (_vm.dayData.incomes.in.length || _vm.dayData.incomes.out.length)
                ? [
                    _c("p", [_vm._v("Инкассации:")]),
                    _vm._v(" "),
                    _vm._l(_vm.dayData.incomes.in, function (inc) {
                      return _c(
                        "p",
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$AllCurrencies[inc.currency_id].currency
                            ) + ":\n        "
                          ),
                          _c("strong", [
                            _vm._v(_vm._s(inc.sum.toLocaleString("ru-RU"))),
                          ]),
                          _vm._v(
                            "\n        (" +
                              _vm._s(
                                _vm.divisions[inc.division_id].user.short_name
                              ) +
                              " "
                          ),
                          _vm._l(
                            _vm.divisions[inc.division_id].stores,
                            function (store, i) {
                              return _c("span", [
                                _vm._v(
                                  _vm._s(i !== 0 ? ", " : "") +
                                    _vm._s(
                                      _vm.$AllStores[store.object_id]
                                        .short_title
                                    )
                                ),
                              ])
                            }
                          ),
                          _vm._v(")\n      "),
                        ],
                        2
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.dayData.incomes.out, function (inc) {
                      return _c("p", [
                        _vm._v(
                          _vm._s(_vm.$AllCurrencies[inc.currency_id].currency) +
                            ": "
                        ),
                        _c("strong", [
                          _vm._v(
                            "-\n        " +
                              _vm._s(inc.sum.toLocaleString("ru-RU"))
                          ),
                        ]),
                      ])
                    }),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("hr"),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.useCashOut
        ? _c(
            "div",
            [
              _vm._l(_vm.getActualCashData(), function (val, title) {
                return _c("p", [
                  _vm._v(_vm._s(_vm.titles[title]) + ":\n      "),
                  _c("strong", [_vm._v(_vm._s(val.toLocaleString("ru-RU")))]),
                ])
              }),
              _vm._v(" "),
              _c("hr"),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "figures flex justify-content-between" }, [
        _c(
          "div",
          [
            +_vm.divisionCurrency.id !== 33
              ? _vm._l(
                  _vm.balance.currencyBalance?.balance ?? [],
                  function (b, currId) {
                    return +b.amount
                      ? _c("p", [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$AllCurrencies[currId].currency) +
                              ": "
                          ),
                          _c("strong", [
                            _vm._v(_vm._s(b.amount.toLocaleString("ru-RU"))),
                          ]),
                          _vm._v(" "),
                          +currId === +_vm.divisionCurrency.id
                            ? _c("span", [
                                _vm._v(
                                  "\n            ( RUB: ~ " +
                                    _vm._s(
                                      _vm
                                        .getCurrencyBalance(b.amount)
                                        .toLocaleString("ru-RU")
                                    ) +
                                    " )\n          "
                                ),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e()
                  }
                )
              : _vm._l(_vm.getTotalSum(), function (val, curr) {
                  return val || +curr === _vm.divisionCurrency?.id
                    ? _c("p", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$AllCurrencies[curr].currency) +
                            ":\n          "
                        ),
                        _c("strong", [
                          _vm._v(_vm._s(val.toLocaleString("ru-RU"))),
                        ]),
                      ])
                    : _vm._e()
                }),
          ],
          2
        ),
        _vm._v(" "),
        false
          ? _c(
              "div",
              [
                _vm.$AllDivisions[_vm.division].settings &&
                _vm.$AllDivisions[_vm.division].settings.use_prepaid_cards &&
                _vm.totalCardsSum
                  ? [
                      _c("p", { staticClass: "text-right" }, [
                        _c("i", { staticClass: "icon-fa icon-fa-credit-card" }),
                        _vm._v(" "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.totalCardsSum.toLocaleString("ru-RU"))
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      +_vm.division === 1
                        ? _c("p", { staticClass: "fs-12 text-right" }, [
                            _vm._v(
                              "б/н за " +
                                _vm._s(_vm.$route.query.date) +
                                "\n          "
                            ),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.balance?.cards?.end?.totalSum ?? 0)
                              ),
                            ]),
                            _vm._v(" из них регионы\n          "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  +(_vm.balance?.cards?.end?.totalSum ?? 0) -
                                    +(_vm.orders?.grouped?.no_cash_total ?? 0)
                                )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.balance.cards.end.cardsCashOut
                        ? [
                            _c("p", { staticClass: "fs-12 text-right" }, [
                              _vm._v("обналичивание: "),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.balance.cards.end.cardsCashOut.sum.toLocaleString(
                                      "ru-RU"
                                    )
                                  )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "text-right" }, [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-credit-card",
                              }),
                              _vm._v(" "),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    (
                                      ((_vm.balance.cards &&
                                        _vm.balance.cards.start.totalSum) ||
                                        0) +
                                      ((_vm.balance.cards &&
                                        _vm.balance.cards.end.totalSum) ||
                                        0) -
                                      ((_vm.balance.cards &&
                                        _vm.balance.cards.end.cardsCashOut
                                          .sum) ||
                                        0)
                                    ).toLocaleString("ru-RU")
                                  )
                                ),
                              ]),
                            ]),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.allowToCashoutCard &&
                      !_vm.balance.cards.end.cardsCashOut
                        ? _c("div", { staticClass: "flex" }, [
                            _vm.allowToCashoutCard &&
                            !_vm.balance.cards.end.cardsCashOut &&
                            _vm.noCashOrders
                              ? _c("div", { staticClass: "fs-14 mr-2" }, [
                                  _c(
                                    "div",
                                    [
                                      _vm.noCashOrders?.ordersInProgress?.orders
                                        .length
                                        ? _c(
                                            "v-popover",
                                            { attrs: { "auto-hide": true } },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "badge badge-info pointer",
                                                },
                                                [_vm._v("Заявки")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "template",
                                                { slot: "popover" },
                                                [
                                                  _c(
                                                    "div",
                                                    _vm._l(
                                                      _vm.noCashOrders
                                                        .ordersInProgress
                                                        .orders,
                                                      function (o) {
                                                        return _c("p", [
                                                          _vm._v(
                                                            _vm._s(o.id) +
                                                              " (" +
                                                              _vm._s(o.price) +
                                                              ")"
                                                          ),
                                                        ])
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              ),
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                      _vm._v(
                                        "\n              в работе:\n              "
                                      ),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            (
                                              _vm.noCashOrders?.ordersInProgress
                                                ?.total_sum || 0
                                            ).toLocaleString("ru-RU")
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v("Зачисление по SMS: "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.noCashOrders.incomesBySms.toLocaleString(
                                            "ru-RU"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", [
                                    _vm._v("Снято с карт: "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.noCashOrders.cashOutSum.toLocaleString(
                                            "ru-RU"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "text-right" },
                              [
                                _c("CardBalance", {
                                  ref: "cardsBalance",
                                  attrs: { date: _vm.getReportDate() },
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-outline-success btn-xs",
                                    on: {
                                      click: () => _vm.openCardCashoutModal(),
                                    },
                                  },
                                  [_vm._v("обналичить карты\n            ")]
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.allowToEditCashOut
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-info btn-xs",
                              attrs: { type: "button" },
                              on: {
                                click: () =>
                                  _vm.openCardCashoutModal(
                                    _vm.balance.cards.end.cardsCashOut
                                  ),
                              },
                            },
                            [
                              _vm._v(
                                "редактировать\n          обналичивание\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }